module.exports = __webpack_public_path__ + "media/images/front/home_1-ca6d7be5f01998166e1a2ce3af1ce7ec.webp";